/**
 * Twitch API types and interfaces
 * Comprehensive type definitions for Twitch API integration
 */
// ============================================================================
// ERROR TYPES
// ============================================================================
export var TwitchErrorCode;
(function (TwitchErrorCode) {
    TwitchErrorCode["AUTH_FAILED"] = "AUTH_FAILED";
    TwitchErrorCode["USER_NOT_FOUND"] = "USER_NOT_FOUND";
    TwitchErrorCode["RATE_LIMITED"] = "RATE_LIMITED";
    TwitchErrorCode["API_ERROR"] = "API_ERROR";
    TwitchErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    TwitchErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
})(TwitchErrorCode || (TwitchErrorCode = {}));
//# sourceMappingURL=twitch.js.map